import React, { useEffect, useState } from "react";
import { Layout, Breadcrumb } from "antd";
import Sidebar from "../../Components/Sidebar";
import { useUserContext } from "../../../../Context/UserContext";
const { Content } = Layout;

export default function AdminCommunity() {
  const [posts, setPosts] = useState([]);
  const { axiosInstance } = useUserContext();

  useEffect(() => {
    (async () => {
      const { data } = await axiosInstance.get("/post");
    })();
  }, []);

  return (
    <Layout hasSider style={{ minHeight: "80vh" }}>
      <Sidebar />
      <Layout
        style={{
          padding: "5px 24px 24px",
          height: "92vh",
          overflowY: "scroll",
        }}
      >
        <Content
          style={{
            minHeight: 280,
          }}
        >
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Admin</Breadcrumb.Item>
            <Breadcrumb.Item>Community</Breadcrumb.Item>
          </Breadcrumb>
        </Content>
      </Layout>
    </Layout>
  );
}
